const pattern = /(?:(qa(?:b?)|ci|dev|release|stage|cn)-)?[\w-]+\.(zhihuiya|patsnap)\.(com|eu)/;
export var DeployEnv;
(function (DeployEnv) {
    DeployEnv["QA"] = "qa";
    DeployEnv["CI"] = "ci";
    DeployEnv["DEV"] = "dev";
    DeployEnv["CN"] = "cn";
    DeployEnv["CNB"] = "cnb";
    DeployEnv["US"] = "us";
    DeployEnv["STAGE"] = "stage";
    DeployEnv["EU"] = "eu";
})(DeployEnv || (DeployEnv = {}));
export var Domain;
(function (Domain) {
    Domain["EU"] = "patsnap.eu";
    Domain["EN"] = "patsnap.com";
    Domain["CN"] = "zhihuiya.com";
})(Domain || (Domain = {}));
const deployEnv = (() => {
    const result = window.location.host.match(pattern);
    if (!result)
        return DeployEnv.QA;
    const [, env, name, domain] = result;
    if (!env) {
        if (domain === DeployEnv.EU)
            return DeployEnv.EU;
        if (name === 'zhihuiya')
            return DeployEnv.CN;
        return DeployEnv.US;
    }
    return env;
})();
/**
 * 二级域名
 */
export var SLD;
(function (SLD) {
    SLD["WWW"] = "www";
    SLD["WORKSPACE"] = "workspace";
    SLD["ACCOUNT"] = "account";
    SLD["ANALYTICS"] = "analytics";
    SLD["INSIGHTS"] = "insights";
    SLD["DISCOVERY"] = "discovery";
    SLD["BIO"] = "bio";
    SLD["SYNAPSE"] = "synapse";
    SLD["SYNAPSE_CHAT"] = "synapse-chat";
    SLD["CHEMICAL"] = "chemical";
    /**
     * 资产管理
     */
    SLD["INNOSNAP"] = "innosnap";
    /**
     * 智慧芽学社(国外)
     */
    SLD["ACADEMY"] = "academy";
    /**
     * 智慧芽学社(国内)
     */
    SLD["COURSE_2C"] = "x";
    /**
     * 企业版学社(国内)
     */
    SLD["COURSE_2B"] = "academy";
    SLD["HELP"] = "help";
    SLD["ADMIN"] = "admin";
    SLD["PASSPORT"] = "passport";
    SLD["HOME"] = "home";
    SLD["DASHBOARD"] = "dashboard";
    SLD["LAB"] = "lab";
    SLD["OPEN"] = "open";
    /**
    * 资源
    */
    SLD["STATIC"] = "static-common";
    /**
    * 服务
    */
    SLD["CHEMICAL_SERVICE"] = "chemical-service";
    SLD["INSIGHTS_SERVICE"] = "insights-service";
    SLD["DASHBOARD_SERVICE"] = "dashboard-service";
    SLD["WORKSPACE_SERVICE"] = "workspace-service";
    SLD["CORE_BASIC_SERVICE"] = "basic-service";
    SLD["CORE_SEARCH_SERVICE"] = "search-service";
    SLD["CORE_PLG_SERVICE"] = "plg-service";
    SLD["PAPER_SERVICE"] = "paper-service";
    SLD["ACCOUNT_SERVICE"] = "account-service";
    SLD["CONSOLE_SERVICE"] = "console-service";
    SLD["TFFI"] = "tffi";
    SLD["EUREKA"] = "eureka";
    SLD["PHARMSNAP"] = "pharmsnap";
    SLD["TELECOM"] = "telecom";
    SLD["EUREKA_INSIGHTS"] = "eureka-insights";
    /**
     * 老insights
     */
    SLD["INSIGHTS_OLD"] = "insightsv1";
})(SLD || (SLD = {}));
const NOT_IN_EU = [
    SLD.ACADEMY,
    SLD.HELP,
];
//
/**
 * 如果 location.hostname 模式是 {sld}-{suffix}.[patsnap|zhihuiya].com, 则返回 suffix
 * @returns {string} suffix
 */
export function getSldSuffixName() {
    const hostname = window.location.hostname;
    const match = hostname.match(/(\w+)-(\w+)\.(patsnap|zhihuiya)\.(com|eu)/);
    if (match) {
        return match[2];
    }
    return '';
}
export class Site {
    constructor(opt) {
        this.protocol = 'https';
        this.sld = opt.sld;
        this.pathname = opt.pathname;
        this.env = opt.env || process.env.VUE_APP_DEPLOY_ENV || deployEnv;
    }
    get prefix() {
        if (this.env === DeployEnv.US || this.env === DeployEnv.CN || this.env === DeployEnv.EU || this.env === DeployEnv.CNB) {
            return '';
        }
        return `${this.env}-`;
    }
    get domain() {
        if (this.env === DeployEnv.EU) {
            if (NOT_IN_EU.includes(this.sld)) {
                return Domain.EN;
            }
            return Domain.EU;
        }
        if (this.env === DeployEnv.US) {
            return Domain.EN;
        }
        return Domain.CN;
    }
    get href() {
        let _href = `${this.protocol}://`;
        // @ts-ignore
        if (window && typeof window._custom_site_href === 'function') {
            try {
                // @ts-ignore
                const href = window._custom_site_href(this);
                if (href) {
                    return href;
                }
            }
            catch (e) {
            }
        }
        else if (getSldSuffixName() === 'siemens') {
            if (this.sld !== SLD.PASSPORT && this.sld !== SLD.HELP) {
                this.sld = `${this.sld}-${getSldSuffixName()}`;
            }
        }
        if (this.prefix) {
            _href = `${_href}${this.prefix}`;
        }
        if (this.env === DeployEnv.CNB && [
            // 填入有B环境的
            SLD.WORKSPACE,
            SLD.ACCOUNT,
            SLD.ADMIN,
            SLD.ANALYTICS,
            SLD.STATIC,
            SLD.HOME,
            SLD.INSIGHTS,
            SLD.DASHBOARD,
            SLD.EUREKA,
        ].includes(this.sld)) {
            _href = `${_href}cn-`;
        }
        if (this.sld) {
            _href = `${_href}${this.sld}`;
        }
        _href = `${_href}.${this.domain}`;
        if (this.pathname) {
            _href = `${_href}/${this.pathname}`;
        }
        return transformUrlProxy(this.sld, _href);
    }
    toString() {
        return this.href;
    }
}
const SUPPORTED_PROXY_DOMAINS = ['athensams.net', 'libproxy1.nus.edu.sg', 'library.sutd.edu.sg', 'lib.ezproxy.ust.hk', 'lib.ezproxy.hkust.edu.hk', 'libproxy.mit.edu', 'libproxy2.nus.edu.sg', 'sutd.idm.oclc.org'];
const SPECIAL_PRODUCTS = [
    SLD.WORKSPACE,
    SLD.ACCOUNT,
    SLD.ANALYTICS,
    SLD.INSIGHTS,
    SLD.DISCOVERY,
    SLD.EUREKA_INSIGHTS,
    SLD.BIO,
    SLD.SYNAPSE,
    SLD.CHEMICAL,
    SLD.INNOSNAP,
    SLD.ACADEMY,
    SLD.COURSE_2B,
    SLD.COURSE_2C,
    SLD.HELP,
    SLD.ADMIN,
    SLD.PASSPORT,
    SLD.HOME,
    SLD.DASHBOARD,
    SLD.STATIC,
    SLD.CHEMICAL_SERVICE,
    SLD.INSIGHTS_SERVICE,
    SLD.DASHBOARD_SERVICE,
    SLD.WORKSPACE_SERVICE,
    SLD.CORE_BASIC_SERVICE,
    SLD.CORE_SEARCH_SERVICE,
    SLD.CORE_PLG_SERVICE,
    SLD.PAPER_SERVICE,
    SLD.ACCOUNT_SERVICE,
    SLD.CONSOLE_SERVICE,
    SLD.INSIGHTS_OLD
].sort().reverse();
export const HAS_PROXY = SUPPORTED_PROXY_DOMAINS.find(domain => window.location.host.indexOf(domain) > -1);
const currentProduct = SPECIAL_PRODUCTS.find((p) => {
    return window.location.hostname.match(new RegExp(`${p}.(zhihuiya|patsnap)`));
}) || 'analytics';
export function transformUrlProxy(product, url, from) {
    if (url && HAS_PROXY && SPECIAL_PRODUCTS.includes(product)) {
        return url.replace(/^(http:|https:)?\/\/([a-zA-Z-0-9.:]+)/, () => {
            return `${window === null || window === void 0 ? void 0 : window.location.protocol}//${window === null || window === void 0 ? void 0 : window.location.host.replace(from || currentProduct, product)}`;
        });
    }
    return url;
}
//# sourceMappingURL=site.js.map